import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import './login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();

  const url = 'http://10.202.101.5:8000/users/token';

  const formData = new URLSearchParams();
  formData.append('grant_type', 'password');
  formData.append('username', email);
  formData.append('password', password);
  formData.append('scope', '');
  formData.append('client_id', 'string');
  formData.append('client_secret', 'string');

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: data.detail || response.statusText,
      });
      return;
    }

    // Store tokens and user info
    localStorage.setItem('access_token', data.access_token);
    sessionStorage.setItem('access_token', data.access_token);

    localStorage.setItem('refresh_token', data.refresh_token);
    sessionStorage.setItem('refresh_token', data.refresh_token);

    localStorage.setItem('user_role', data.role || '');
    sessionStorage.setItem('user_role', data.role || '');

    localStorage.setItem('user_full_name', data.full_name || '');
    sessionStorage.setItem('user_full_name', data.full_name || '');

    // Sweet alert success
    Swal.fire({
      icon: 'success',
      title: 'Login Successful',
      showConfirmButton: false,
      timer: 1500,
    }).then(() => {
      navigate('/dashboard');
    });

  } catch (error) {
    console.error('Login error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'An error occurred during login.',
    });
  }
};


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container">
      {/* Left Section */}
      <div className="left-section">
        <img src="/amiand-logo.svg" alt="Amiand Logo" className="logo" />
        <h1 className="title">Asset Management System</h1>
        <img src="/illustration.svg" alt="Illustration" className="illustration" />
      </div>

      {/* Right Section */}
      <div className="right-section">
        <h2 className="login-title">Login</h2>
        <div className="login-card">
          <form onSubmit={handleLogin} className="login-form">
            {/* Email Field */}
            <div className="form-group">
              <label className="form-label">Email ID:</label>
              <div className="input-wrapper">
                <span className="input-icon">
                  <img src="email.svg" alt="Email Icon" />
                </span>
                <input
                  type="email"
                  placeholder="Enter your email id here"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  required
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="form-group">
              <label className="form-label">Password:</label>
              <div className="input-wrapper">
                <span className="input-icon">
                  <img src="lock.svg" alt="Lock Icon" />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password here"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <span className="eye-icon" onClick={togglePasswordVisibility}>
                  <img
                    src={showPassword ? 'lockeye.svg' : 'openeye.svg'}
                    alt={showPassword ? 'Hide Password' : 'Show Password'}
                    style={{ cursor: 'pointer' }}
                  />
                </span>
              </div>
            </div>

            {/* Remember Me and Forgot Password */}
            <div className="form-options">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>Remember Me</span>
              </label>
              <a href="/" className="forgot-password">
                Forgot Password?
              </a>
            </div>

            {/* Login Button */}
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
